(function () {
  var storageKey = 'verome:wishlist:v1';

  var selectors = {
    button: '[data-wishlist-button]',
    count: '[data-wishlist-count]',
    items: '[data-wishlist-items]',
    empty: '[data-wishlist-empty]',
    label: '[data-wishlist-label]',
    remove: '[data-wishlist-remove]',
    translations: '[data-wishlist-translations]'
  };

  var defaultTranslations = {
    add: 'Zu Favoriten',
    saved: 'Favorit',
    remove: '[[title]] aus Favoriten entfernen'
  };
  var readyMarked = false;

  function readItems() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      return Array.isArray(parsed) ? parsed.filter(function (item) {
        return item && item.id;
      }) : [];
    }
    catch (error) {
      return [];
    }
  }

  function writeItems(items) {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(items.slice(0, 50)));
    }
    catch (error) {}
  }

  function isSaved(items, id) {
    return items.some(function (item) {
      return String(item.id) === String(id);
    });
  }

  function readTranslations() {
    var source = document.querySelector(selectors.translations);
    var translations = Object.assign({}, defaultTranslations);

    if (!source) return translations;

    try {
      var parsed = JSON.parse(source.textContent || '{}');

      Object.keys(defaultTranslations).forEach(function (key) {
        if (parsed[key]) translations[key] = parsed[key];
      });
    }
    catch (error) {}

    return translations;
  }

  function withTitle(template, title) {
    return String(template || '').replace('[[title]]', title);
  }

  function getButtonItem(button) {
    return {
      id: String(button.getAttribute('data-product-id') || ''),
      title: button.getAttribute('data-product-title') || '',
      url: button.getAttribute('data-product-url') || '#',
      image: button.getAttribute('data-product-image') || '',
      price: button.getAttribute('data-product-price') || ''
    };
  }

  function updateCounts(items) {
    document.querySelectorAll(selectors.count).forEach(function (count) {
      count.textContent = items.length;
      count.hidden = items.length === 0;
    });
  }

  function updateButtons(items) {
    var translations = readTranslations();

    document.querySelectorAll(selectors.button).forEach(function (button) {
      var saved = isSaved(items, button.getAttribute('data-product-id'));
      var label = button.querySelector(selectors.label);
      var title = button.getAttribute('data-product-title') || '';

      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      button.classList.toggle('is-saved', saved);
      button.setAttribute('aria-label', (saved ? translations.saved : translations.add) + ': ' + title);

      if (label) {
        label.textContent = saved ? translations.saved : translations.add;
      }
    });
  }

  function markButtonsReady() {
    if (readyMarked) return;

    readyMarked = true;
    window.requestAnimationFrame(function () {
      document.querySelectorAll(selectors.button).forEach(function (button) {
        button.classList.add('is-ready');
      });
    });
  }

  function createRemoveIcon() {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('aria-hidden', 'true');

    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M6 6L18 18M18 6L6 18');
    svg.appendChild(path);

    return svg;
  }

  function renderDrawer(items) {
    var list = document.querySelector(selectors.items);
    var empty = document.querySelector(selectors.empty);
    var translations = readTranslations();

    if (!list || !empty) return;

    var hasItems = items.length > 0;
    var drawer = list.closest('.verome-wishlist-drawer');

    list.innerHTML = '';
    empty.hidden = hasItems;
    empty.setAttribute('aria-hidden', hasItems ? 'true' : 'false');
    empty.style.display = hasItems ? 'none' : '';
    list.hidden = !hasItems;
    list.style.display = hasItems ? '' : 'none';

    if (drawer) {
      drawer.classList.toggle('is-empty', !hasItems);
    }

    items.forEach(function (item) {
      var article = document.createElement('article');
      article.className = 'verome-wishlist-item';

      var mediaLink = document.createElement('a');
      mediaLink.className = 'verome-wishlist-item__media';
      mediaLink.href = item.url;
      mediaLink.setAttribute('aria-label', item.title);

      if (item.image) {
        var image = document.createElement('img');
        image.src = item.image;
        image.alt = item.title;
        image.loading = 'lazy';
        mediaLink.appendChild(image);
      }
      else {
        var placeholder = document.createElement('span');
        placeholder.className = 'verome-wishlist-item__placeholder';
        placeholder.textContent = 'V';
        mediaLink.appendChild(placeholder);
      }

      var details = document.createElement('div');
      details.className = 'verome-wishlist-item__details';

      var title = document.createElement('a');
      title.className = 'verome-wishlist-item__title reversed-link';
      title.href = item.url;
      title.textContent = item.title;
      details.appendChild(title);

      if (item.price) {
        var price = document.createElement('p');
        price.className = 'verome-wishlist-item__price';
        price.textContent = item.price;
        details.appendChild(price);
      }

      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'verome-wishlist-item__remove';
      remove.setAttribute('data-wishlist-remove', item.id);
      remove.setAttribute('aria-label', withTitle(translations.remove, item.title));
      remove.appendChild(createRemoveIcon());

      article.appendChild(mediaLink);
      article.appendChild(details);
      article.appendChild(remove);

      list.appendChild(article);
    });
  }

  function sync() {
    var items = readItems();
    updateCounts(items);
    updateButtons(items);
    renderDrawer(items);
    markButtonsReady();
  }

  function toggleItem(button) {
    var item = getButtonItem(button);
    if (!item.id) return;

    var items = readItems();
    var saved = isSaved(items, item.id);
    var nextItems;

    if (saved) {
      nextItems = items.filter(function (savedItem) {
        return String(savedItem.id) !== item.id;
      });
    }
    else {
      nextItems = [item].concat(items.filter(function (savedItem) {
        return String(savedItem.id) !== item.id;
      }));
    }

    writeItems(nextItems);
    sync();
  }

  document.addEventListener('click', function (event) {
    var wishlistButton = event.target.closest(selectors.button);

    if (wishlistButton) {
      event.preventDefault();
      event.stopPropagation();
      toggleItem(wishlistButton);
      return;
    }

    var removeButton = event.target.closest(selectors.remove);

    if (removeButton) {
      var items = readItems().filter(function (item) {
        return String(item.id) !== String(removeButton.getAttribute('data-wishlist-remove'));
      });

      writeItems(items);
      sync();
    }
  }, true);

  window.addEventListener('storage', function (event) {
    if (event.key === storageKey) sync();
  });

  document.addEventListener('shopify:section:load', function () {
    window.requestAnimationFrame(sync);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  }
  else {
    sync();
  }
})();